import React, { useEffect,useState } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import { api, rules,sportlist } from "../../apis/urls";
import ReactPaginate from 'react-paginate';
import { $ } from "react-jquery-plugin";
import moment from "moment";
import { message } from "antd";
import { Button, Popconfirm } from 'antd';
import { decode } from "html-entities";


const CoachListRules = () => {

    const [result, setResult] = useState([]);
    const [searchTitle, setSearchTitle] = useState("");
    const [sort, setSort] = useState("");
    const [order, setOrder] = useState(true);



    const {rid} = useParams();

    localStorage.setItem("coachruleid",rid);

    useEffect(()=>{
        CoachListing();
    },[])

    let navigate = useNavigate();
    let token = "Bearer "+localStorage.getItem('token');

    let CoachListing = (datas,orders) => {

        let token = "Bearer "+localStorage.getItem('token');
        let SortData = datas?datas:'' 
        let orderData = order?'ASC':'DESC'
        
        const instance = axios.create({
            //baseURL: rules+'/coachlist/'+rid,
            baseURL: `${rules}/coachlist/${rid}?sort=${SortData}&order=${orderData}`,
            timeout: 1000000,
            headers: {'authorization': token}
        });
        instance.get('').then((response) =>{    
            setResult(response.data)
        }).catch((error) =>{     
            console.log('error',error.message)  
        });
    }

    const sortingData = (datas) => {
        setSort(datas)
        setOrder(!order)
        CoachListing(datas, order)
      }

    const instances = axios.create({
        baseURL: api,
        timeout: 1000000,
        headers: {'authorization': token}
    });

    const findByTitles = name => {
        return instances.get(`rules/coachlist/${rid}?search=${name}`);
    };

    const onChangeSearchTitle = (e) => {
        const searchTitle = e.target.value;
        setSearchTitle(searchTitle);
        findByTitles(searchTitle)
        .then(response => {

            if(response.data.message=== "success"){
                setResult(response.data);
                
            }else{
                setResult(false)
            }
        })
        .catch(e => {
            console.log(e);
        });
    };
    
    const handleSubmit = (itemid) => {

        console.log(itemid);

        let token = "Bearer "+localStorage.getItem('token');
        const data = {
           attemptid:itemid
        }
        console.log('all datas',data)

        const instance = axios.create({

            baseURL: rules+"/approvereattempt",

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.patch('',data).then((response) =>{

            console.log("res data",response.data.message)

            if(response.data.message === "Success")
            {
                window.location.reload();
            }
           
          }).catch((error) =>{
            
        });

    }
    
    const exportCoaches  = () => { 

        let token = "Bearer "+localStorage.getItem('token');

        const instance = axios.create({
            baseURL: api+"impex/coaches/export/"+rid,
            timeout: 1000000,
            headers: {'authorization': token}
        });
        instance.get('').then((response) =>{
            message.success("Export successfully")
            window.open(api+"impex/download/coaches/"+response.data.fileName, '_blank')
        }).catch((error) =>{     
            console.log('error',error.message)  
        });
}
    let sl=1;
    return(
        <div>
            <aside class="right-side areas">
                <div class="content-area dash-contentss">

                <div class="page-title-wrpr">
                    <div class="page-title-left-column">
                        <h2 class="page-title">Coaches - {decode(result.rule_name)}</h2>
                    </div>
                    <div class="page-rightside-action-column">
                        <div class="input-groups mt-3 mb-3 search-grps">
                            <input type="text" 
                            class="form-controls search-bar asso-search"             
                            // value={searchTitle}
                            onChange={onChangeSearchTitle}
                            placeholder="Search Name" />
                            <button  class="btn btn-search icon-search assosearch-btn"></button>
                            </div>
                        </div>
                    </div>


                    <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                        <li class="breadcrumb-item active" aria-current="page"><Link to="/rules">Rules Tests</Link></li>
                        <li class="breadcrumb-item active" aria-current="page">Coaches</li>

                    </ol>
                    <div><b>List of Coaches : {result.coachpasscount} </b></div>
                    </nav>

                    <div className="page-rightside-action-column mb-3">    
                <button onClick={exportCoaches} style={{padding:"10px", background:'#4077c7', borderRadius:"5px", color:'#fff'}} className="addbtnitem-link text-anchor">Export</button>
            </div>

                    <div>
                        <div class="containers" style={{overflow:'auto'}}>


                            <table class="table table-rules">
                                <thead>
                                    <tr className="rules-table-head">
                                    <th scope="col">Sl.No</th>
                                    <th scope="col">Name</th>
                                    <th scope="col" onClick={()=>{sortingData("schoolname")}}>School<i style={{fontSize:'20px', position:'relative', top:"4px"}} 
                                     className={sort === "schoolname" && order?"icon-arrow_drop_down":sort === "schoolname" && !order?"icon-arrow_drop_up":"icon-swap_vert"}></i></th>
                                    <th scope="col">Date of last attempt</th>
                                    <th scope="col">Score</th>
                                    <th scope="col">Status</th>
                                    <th style={{textAlign:'center'}}scope="col">Actions</th>
                                    <th scope="col">View</th>
                                    
                                   

                                    </tr>   
                                </thead>
                                <tbody className="rules-table-content">

                                    {result.data?.map((item, index) =>(
                                            <tr>
                                                <td scope="row">{sl++}</td>
                                                <td>{decode(item.name)}</td> 
                                                <td>{decode(item.schoolname)}</td>
                                               
                                                <td>{moment(item.latestTest.attempted_date).format('MMMM DD, YYYY')}</td>
                                                <td>{item.latestTest.user_totalmarks} / {item.latestTest.totalmarks}</td>
                                                <td>{item.latestTest.status}</td>
                                                <td>
                                                <div class="">
                                                <div class="update-date">
                                                    {item.latestTest.test_attempted >= 2 && item.latestTest.status === "FAIL" && item.latestTest.reattempt === "INACTIVE" ? (
                                                        <button 
                                                        onClick={() => { handleSubmit(item.latestTest.id) }} 
                                                        style={{ padding: "10px", background: '#4077c7', borderRadius: "5px", color: '#fff' }} 
                                                        className="addbtnitem-link text-anchor"
                                                        >
                                                        Enable re-attempt
                                                        </button>
                                                    ) : null
                                                    }
                                                </div>
                                            </div>
                                                </td>
                                                
                                                <td>



                                                    <div className="showicons roundicons-text">
                                                        <div className="list-action-wrpr" style={{display:'block'}}>
                                                

                                                        <div style={{width:'10px'}} />
                                                       

                                                        <div style={{width:'10px'}} />
                                                        

                                                        <div style={{width:'10px'}} />

                                                        <button style={{top:"-7px",display:"block"}}  onClick={()=>{navigate("/coach_view/"+item.id)}} data-toggle="tooltip" title="View">
                                                            <i class="icon-eye" style={{background:'black'}}></i>
                                                            <span></span>
                                                        </button>


                                                    </div>
                                                    </div>
                                                </td>                   
                                            </tr>
                                        ))
                                    }
                                    {
                                        !result.data?
                                        (<div className="nodata">
                                            <h2>Sorry! No one had attended the test</h2>
                                        </div>):null
                        
                                    }

                                
                                </tbody>

                                

                            </table>
                            </div>


                    </div>
                </div>
            </aside>
        </div>

    )
}

export default CoachListRules;